import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/.pnpm/@vercel+speed-insights@1.0.12_next@14.2.5_@babel+core@7.24.9_babel-plugin-macros@3.1.0_react-_i5irr6emasnhtihfqxjxlm4wmu/node_modules/@vercel/speed-insights/dist/next/index.mjs");
